import Navbar from "@/components/dibs_landing_page/Navbar";
import Footer from "@/components/dibs_landing_page/Footer";
import PricingPlans from "@/components/dibs_landing_page/PricingPlans";

export default function Pricing() {
  return (
    <>
      <a href="#main-content" className="dv-skip-link">
        Skip to content
      </a>
      <Navbar />
      <PricingPlans />
      <Footer />
    </>
  );
}
